// BRAND_CHROME registry — canonical token table per CHG-1263 §1.
//
// Source of truth: specs/_product/dashboard-v2-brand-variants.md §1.1-§1.3
// Verified against: specs/seeds/dashboard-v2/brand-variant-readiness-gates.yaml
// (brandChrome.test.ts asserts this table matches the gates yaml's expected
// values for all 3 variants × 7 tokens; that test IS the in-process verifier
// behind the readiness gate flip in CHG-1267.)
//
// IMPORTANT: variant_id "_default" is the CHG-1263 spec name for the Alora
// brand. The runtime detectBrand() function in lib/runtime-base-urls.ts uses
// "aloragiving" instead. BrandContext bridges the two via variantIdFromBrand().

import type { Brand } from "../lib/runtime-base-urls";

/** Spec-side variant identifier per CHG-1263 §1. */
export type BrandVariantId = "_default" | "mohseen" | "alorachurch";

/** Chrome token bundle for a single brand variant. */
export interface BrandChrome {
  variant_id: BrandVariantId;
  display_name: string;
  wordmark: string;
  logo_url: string;
  favicon_url: string;
  sidebar_accent_color: string;  // hex, e.g. "#6366F1"
  login_bg_color: string;        // hex, e.g. "#F5F3FF"
  tagline: string;
}

export const BRAND_CHROME: Record<BrandVariantId, BrandChrome> = {
  _default: {
    variant_id: "_default",
    display_name: "Alora Giving",
    wordmark: "Alora Giving",
    logo_url: "/assets/brands/alora/logo.svg?v=7428e5f2",
    favicon_url: "/assets/brands/alora/favicon.ico?v=f4ea45f9",
    sidebar_accent_color: "#6366F1",
    login_bg_color: "#F5F3FF",
    tagline: "Giving Made Simple",
  },
  mohseen: {
    variant_id: "mohseen",
    display_name: "Mohseen",
    wordmark: "Mohseen",
    logo_url: "/assets/brands/mohseen/logo.svg?v=9e00f57e",
    favicon_url: "/assets/brands/mohseen/favicon.ico?v=96bbe298",
    sidebar_accent_color: "#1B5E20",
    login_bg_color: "#F1F8E9",
    tagline: "Islamic Giving, Simplified",
  },
  alorachurch: {
    variant_id: "alorachurch",
    display_name: "AloraChurch",
    wordmark: "AloraChurch",
    logo_url: "/assets/brands/alorachurch/logo.svg",
    favicon_url: "/assets/brands/alorachurch/favicon.svg",
    sidebar_accent_color: "#1565C0",
    login_bg_color: "#E3F2FD",
    tagline: "Church Giving Made Simple",
  },
};

/** Map runtime-base-urls Brand → CHG-1263 spec variant_id. */
export function variantIdFromBrand(brand: Brand): BrandVariantId {
  if (brand === "mohseen") return "mohseen";
  if (brand === "alorachurch") return "alorachurch";
  // "aloragiving" and "unknown" both fall back to platform default per
  // CHG-1263 §2.5 (unknown hostname fallback).
  return "_default";
}
